// Course edit route (/dashboard/onboarding/modules/:id).
//
// Presents the shared CourseCanvasDrawer in edit mode, so editing a course
// looks identical to creating one (wide island slide-over) without rewiring
// the ~6 places that link here. Closing returns to the previous screen.

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CourseCanvasDrawer from './CourseCanvasDrawer';

const EmployerModuleDetailPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    if (!id) return null;

    // Return to wherever the editor was opened from (Moduler list, the course
    // detail page, Bibliotek, a source, or Link) — not a hardcoded Onboarding
    // page. navigate(-1) follows the actual referrer.
    const goBack = () => navigate(-1);

    return <CourseCanvasDrawer moduleId={id} onClose={goBack} onSaved={goBack} />;
};

export default EmployerModuleDetailPage;
